import { render, staticRenderFns } from "./startPage.vue?vue&type=template&id=28a3cec7&scoped=true&"
import script from "./startPage.vue?vue&type=script&lang=js&"
export * from "./startPage.vue?vue&type=script&lang=js&"
import style0 from "./startPage.vue?vue&type=style&index=0&id=28a3cec7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a3cec7",
  null
  
)

export default component.exports